import axios from "../axios";

const auditionApi = {
  getFlowStepList() {
    return axios({
      //查询FlowStep列表
      url: `/gzeua/FlowStep/QueryList`,
      method: "post",
    });
  },
  getAudItemList() {
    return axios({
      //查询角色列表
      url: `/gzeua/AppraiseAuds/GetAllList?typeCode=GZAppraise`,
      method: "post",
    });
  },
  getAudSubItemList(data) {
    return axios({
      //查询角色列表
      url: `/gzeua/AppraiseAudsItem/Search`,
      method: "post",
      data,
    });
  },
  //获取当前审核记录
  getAudHistory(appcomid) {
    return axios({
      url: `/gzeua/AppraiseCompany/QueryCurrAudsItem?appcomid=${appcomid}`,
      method: "post",
    });
  },
  getAppealHistory(res) {
    return axios({
      url: `/gzeua/AppraiseAppeal/Search`,
      method: "post",
      data: res,
    });
  },

  revokeAppealListByTaskID(appraiseComId) {
    return axios({
      url: `/gzeua/AppraiseAppeal/SubmitBackAppeal?appraiseComId=${appraiseComId}`,
      method: "post",
    });
  },
  exportRegionAuditionHistoryExcel(urlStr, regionId) {
    return axios({
      url: `/gzeua/Excel/${urlStr}?regionId=${regionId}`,
      method: "get",
      responseType: "blob",
    });
  },
  exportRegionCompanyCurrentStatusExcel(regionId) {
    return axios({
      url: `/gzeua/Excel/ExportToExcel2?regionId=${regionId}`,
      method: "get",
      responseType: "blob",
    });
  },
  dealAppealItem(appealId) {
    return axios({
      url: `/gzeua/AppraiseAppeal/AppealDeal?appealId=${appealId}`,
      method: "post",
    });
  },
  //查询当前任务申诉列表
  getAppealListByTaskID(data) {
    return axios({
      url: `/gzeua/AppraiseAppeal/Search`,
      method: "post",
      data,
    });
  },

  //查询当前任务申诉列表
  getAppealList(data) {
    return axios({
      url: `/gzeua/AppraiseAppeal/QueryCompanys`,
      method: "post",
      data,
    });
  },
  getAppealAvailability() {
    return axios({
      url: `/gzeua/AppraiseCompany/GetCurrentUserAppraiseModel`,
      method: "post",
    });
  },

  getZYJReviewListAd(data) {
    return axios({
      url: `/gzeua/TEnvAppraiseCompany/Search`,
      method: "post",
      data,
    });
  },

  getZYJReviewDetail(tenAppraiseCompanyId) {
    return axios({
      url: `/gzeua/TEnvAppraiseCompany/GetCompanyrequestGz`,
      method: "post",
      params: { tenAppraiseCompanyId },
    });
  },

  getZYJReviewListCo(data) {
    return axios({
      url: `/gzeua/TEnvAppraiseCompany/GetAppraiseCompanyList`,
      method: "post",
      data,
    });
  },

  //查询当前任务申诉列表
  saveAppealItem(data) {
    return axios({
      url: `/gzeua/AppraiseAppeal/CreateOrEdit`,
      method: "post",
      data,
    });
  },
  //删除审核流程
  deleteAppealItem(id) {
    return axios({
      url: `/gzeua/AppraiseAppeal/Delete?id=${id}`,
      method: "post",
    });
  },
  //删除审核流程
  advanceAppealList(appraiseComId) {
    return axios({
      url: `/gzeua/AppraiseAppeal/SubmitAppeal?appraiseComId=${appraiseComId}`,
      method: "post",
    });
  },
  //保存审核流程
  saveVerifyList(
    auditsocreradio,
    unitAppraiseComStepId,
    score,
    remark,
    auditsId,
    auditsItemIds,
    auditsItemNames,
    auditsNo,
    itemTitle,
    fileUrl
  ) {
    return axios({
      url: `/gzeua/AppraiseCompany/SaveAudsItem?auditsocreradio=${auditsocreradio}`,
      method: "post",
      data: {
        unitAppraiseComStepId: unitAppraiseComStepId + "",
        score,
        remark,
        auditsId: auditsId + "",
        auditsItemIds,
        auditsItemNames,
        auditsNo: auditsNo + "",
        itemTitle,
        fileUrl,
        creatorName: "a",
      },
    });
  },
  //完成审核
  finishVerifyStep(appcomid) {
    return axios({
      url: `/gzeua/AppraiseCompany/SubmitAudsItem`,
      method: "post",
      params: {
        appcomid,
      },
    });
  },
  //流程退回
  backVerify(appcomid, remark) {
    return axios({
      url: `/gzeua/AppraiseCompany/BackStep?appcomid=${appcomid}&remark=${remark}`,
      method: "post",
    });
  },
  //未填报企业批量提交
  batchAdvanceStep(appraiseComIds) {
    return axios({
      url: `/gzeua/AppraiseCompany/BatchSubmitToAudit?appraiseComIds=${appraiseComIds}`,
      method: "post",
    });
  },
  //批量提交审核
  batchAuditionSubmit(unitappcomids) {
    return axios({
      url: `/gzeua/AppraiseCompany/BatSubmitAudsItem?unitappcomids=${unitappcomids}`,
      method: "post",
    });
  },
  //批量提交下一流程
  batchNextAuditionStep(unitappcomids) {
    return axios({
      url: `/gzeua/AppraiseCompany/BatchForwardStep?unitappcomids=${unitappcomids}`,
      method: "post",
    });
  },
  //删除审核流程
  deleteVerifyStep(itemid) {
    return axios({
      url: `/gzeua/AppraiseCompany/DeleteAudsItem?itemid=${itemid}`,
      method: "post",
    });
  },
  getCanBackStepId() {
    return axios({
      url: `/gzeua/AppraiseCompany/CanBackStepId`,
      method: "get",
    });
  },
};
export default auditionApi;
